import { render, staticRenderFns } from "./beethoven-attachment-metadata-slope.vue?vue&type=template&id=0481a380&"
import script from "./beethoven-attachment-metadata-slope.vue?vue&type=script&lang=ts&"
export * from "./beethoven-attachment-metadata-slope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports